import { render } from "./BuyerInvoices.vue?vue&type=template&id=5488abd6"
import script from "./BuyerInvoices.vue?vue&type=script&lang=js"
export * from "./BuyerInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Storage/Development/VintageTradingPost/chicken-auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__